import { SET_SEARCH_LIST_TOS } from "./actionType";

export default function reducer(state = [], action) {
  switch (action.type) {
    case SET_SEARCH_LIST_TOS: {
      return [...action.payload];
    }
    default:
      return state;
  }
}
